import { useMemo } from "react";

const rand = (seed) => {
  let s = seed;
  return () => {
    s = (s * 16807) % 2147483647;
    return (s - 1) / 2147483646;
  };
};

export default function TradingChart() {
  const { candles, line } = useMemo(() => {
    const r = rand(42);
    const W = 620, H = 340, N = 34;
    let price = 100;
    const candles = [];
    for (let i = 0; i < N; i++) {
      const open = price;
      const drift = (r() - 0.42) * 6;
      const close = open + drift;
      const high = Math.max(open, close) + r() * 3;
      const low = Math.min(open, close) - r() * 3;
      candles.push({ open, close, high, low });
      price = close;
    }
    const min = Math.min(...candles.map((c) => c.low));
    const max = Math.max(...candles.map((c) => c.high));
    const y = (v) => H - 30 - ((v - min) / (max - min)) * (H - 70);
    const bw = W / N;
    const pts = candles.map((c, i) => `${i * bw + bw / 2},${y((c.open + c.close) / 2)}`);
    return {
      candles: candles.map((c, i) => ({
        x: i * bw + bw / 2,
        bw: bw * 0.55,
        up: c.close >= c.open,
        yo: y(c.open), yc: y(c.close), yh: y(c.high), yl: y(c.low),
      })),
      line: pts.join(" "),
    };
  }, []);

  return (
    <svg viewBox="0 0 620 340" className="w-full h-auto" data-testid="hero-trading-chart" role="img" aria-label="Live trading chart preview">
      <defs>
        <linearGradient id="goldLine" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#FFD700" stopOpacity="0.2" />
          <stop offset="100%" stopColor="#FFD700" />
        </linearGradient>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="4" result="b" />
          <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
        </filter>
      </defs>
      {[0, 1, 2, 3, 4].map((i) => (
        <line key={i} x1="0" x2="620" y1={40 + i * 65} y2={40 + i * 65} stroke="rgba(255,255,255,0.05)" strokeDasharray="3 6" />
      ))}
      {candles.map((c, i) => (
        <g key={i}>
          <line x1={c.x} x2={c.x} y1={c.yh} y2={c.yl} stroke={c.up ? "#22C55E" : "#EF4444"} strokeWidth="1.2" opacity="0.85" />
          <rect
            x={c.x - c.bw / 2}
            y={Math.min(c.yo, c.yc)}
            width={c.bw}
            height={Math.max(Math.abs(c.yo - c.yc), 2)}
            rx="1.5"
            fill={c.up ? "#22C55E" : "#EF4444"}
            opacity="0.9"
          />
        </g>
      ))}
      <polyline points={line} fill="none" stroke="url(#goldLine)" strokeWidth="2" filter="url(#glow)" />
      <circle cx="610" cy="70" r="4" fill="#FFD700" filter="url(#glow)" />
    </svg>
  );
}
